type ClassValue = string | false | null | undefined;

export default function cn(...values: ClassValue[]) {
  return values.filter(Boolean).join(' ');
}
